import CostCenterRegistration from './CostCenterRegistration';

export default CostCenterRegistration;
